import { createFileRoute, redirect } from "@tanstack/react-router";

// 301 redirect: legacy WordPress URL -> current canonical page
export const Route = createFileRoute("/cyber-security-montclair")({
  beforeLoad: () => {
    throw redirect({ href: "/services/cyber-security", statusCode: 301 });
  },
});
